import React from "react";
import styled from "styled-components";

import img5 from "./img-5.jpg";
import img6 from "./img-6.jpg";
import img7 from "./img-7.jpg";

const Expertises = () => {
  return (
    <ExpertisesWrapper id="expertises">
      <ExpertisesSentence>Blanditiis unde illum earum</ExpertisesSentence>
      <ExpertisesTitle>Expertises</ExpertisesTitle>
      <ExpertisesGrid>
        <ExpertisesCard>
          <img src={img5} />
          <CardTitle>Coding and Designing</CardTitle>
          <CardContent>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          </CardContent>
        </ExpertisesCard>
        <ExpertisesCard>
          <img src={img6} />
          <CardTitle>Graphics Design</CardTitle>
          <CardContent>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          </CardContent>
        </ExpertisesCard>
        <ExpertisesCard>
          <img src={img7} />
          <CardTitle>Development</CardTitle>
          <CardContent>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          </CardContent>
        </ExpertisesCard>
      </ExpertisesGrid>
    </ExpertisesWrapper>
  );
};

const ExpertisesWrapper = styled.div`
  width: 100vw;
  height: 80vh;
  background-color: #e1f1f5;
  overflow-y: hidden;

  @media screen and (orientation: portrait) {
    height: 155vh;
  }
`;

const ExpertisesSentence = styled.h1`
  margin: 0;
  color: gray;
  font-size: 0.9vw;
  font-weight: 400;
  margin-left: 15vw;
  padding-top: 2vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 1.75vh;
    margin-left: 5vw;
  }
`;
const ExpertisesTitle = styled.h1`
  margin: 0;
  font-size: 2vw;
  color: black;
  font-weight: 500;
  margin-left: 15vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 4.25vh;
    margin-left: 5vw;
  }
`;

const ExpertisesGrid = styled.div`
  width: 72vw;
  height: 75vh;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(1, 1fr);
  justify-items: center;
  align-items: center;
  margin-left: 14vw;

  @media screen and (orientation: portrait) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(3, 1fr);
    margin-top: 3vh;
    height: 145vh;
    width: 90vw;
    margin-left: 5vw;
  }
`;

const ExpertisesCard = styled.div`
  width: 22vw;
  height: 45vh;
  background-color: whitesmoke;
  transform: translateY(-6vh);

  cursor: pointer;

  img {
    margin: 0;
    width: 22vw;
    height: 26vh;
  }

  @media screen and (orientation: portrait) {
    width: 90vw;
    height: 42vh;

    img {
      width: 90vw;
      height: 28vh;
    }
  }
`;

const CardTitle = styled.h1`
  text-align: center;
  color: black;
  font-size: 1.4vw;
  font-weight: 500;
  transform: translateY(3vh);

  @media screen and (orientation: portrait) {
    font-size: 2vh;
    transform: translateY(0vh);
  }
`;

const CardContent = styled.h2`
  text-align: center;
  color: gray;
  font-size: 0.85vw;
  font-weight: 300;
  max-width: 15vw;
  width: 15vw;
  margin-left: 3.5vw;
  transform: translateY(1.5vh);

  @media screen and (orientation: portrait) {
    max-width: 90vw;
    width: 90vw;
    font-size: 1.4vh;
    margin-left: 2.5vw;
    transform: translateY(0vh);
  }
`;

export default Expertises;
